import styled from "styled-components";

const LandingPageWrapper = styled.div`
  h2 {
    text-transform: none;
    text-align: left;
    color: rgb(33, 33, 33);
    font-weight: 400;
    font-size: 34px;
    width: 100%;
    max-width: 1230px;
    margin: auto;
    padding: 50px 20px 20px;
    span {
      border-bottom: 1px solid ${(props) => props.theme.colors.primary.main};
      padding-bottom: 10px;
    }
  }
  .collection-section {
    a {  
      color: #00C3CB; 
    }
    > div {
      width: 100%;
      max-width: 1230px;
      margin: auto;
      @media screen and (max-width: 1270px) {
        padding-left: 20px;
      }
      h2 {
        padding-left: 0;
      }
      span {
        border-bottom: 1px solid ${(props) => props.theme.colors.primary.main};
        width: 90px;
        margin-top: -5px;
        display: block;
      }
    }
  }
`;

export default LandingPageWrapper;
